import { z } from 'zod';
import { collectionBlockSchema, ctaBlockSchema, homepageBlockSchema, quickActionsBlockSchema, resourcesBlockSchema, } from '../../ee/homepage/schema';
import { ParameterError } from '../errors';
import { ProjectMemberRole } from '../projectMemberRole';
import { ContentAsCodeType } from './core';
const reference = z.string().min(1);
const actionSchema = z.union([
    z.object({
        type: z.literal('dashboard'),
        dashboardSlug: reference,
        label: z.string(),
        primary: z.boolean().optional(),
    }),
    z.object({
        type: z.literal('space'),
        spaceSlug: reference,
        label: z.string(),
        primary: z.boolean().optional(),
    }),
    z.object({
        type: z.enum([
            'ask-ai',
            'run-query',
            'browse-dashboards',
            'browse-spaces',
            'my-space',
        ]),
        primary: z.boolean().optional(),
    }),
]);
const blockSchema = z.union([
    ...homepageBlockSchema.options.filter((schema) => !['collection', 'resources', 'quick-actions', 'cta'].includes(schema.shape.type.value)),
    collectionBlockSchema.extend({
        config: collectionBlockSchema.shape.config.extend({
            items: z.array(z.object({
                contentType: z.enum([
                    'chart',
                    'dashboard',
                    'space',
                    'data_app',
                ]),
                slug: reference,
            })),
        }),
    }),
    resourcesBlockSchema.extend({
        config: resourcesBlockSchema.shape.config.extend({
            items: z.array(resourcesBlockSchema.shape.config.shape.items.element
                .omit({ appUuid: true })
                .extend({ appSlug: reference.optional() })),
        }),
    }),
    quickActionsBlockSchema.extend({
        config: z.object({ actions: z.array(actionSchema) }),
    }),
    ctaBlockSchema.extend({
        config: ctaBlockSchema.shape.config.extend({
            target: z.union([
                actionSchema,
                z.object({ type: z.literal('link'), url: z.string() }),
            ]),
        }),
    }),
]);
const documentSchema = z.object({
    contentType: z.literal(ContentAsCodeType.HOMEPAGE),
    version: z.literal(1),
    name: reference,
    config: z.object({
        version: z.literal(1),
        rows: z.array(z.object({ id: z.string(), blocks: z.array(blockSchema).max(2) })),
    }),
    publication: z
        .object({
        isDefault: z.boolean(),
        groups: z.array(z.object({
            name: reference,
            priority: z.number().int().nonnegative(),
        })),
        roles: z.array(z.nativeEnum(ProjectMemberRole)),
    })
        .nullable(),
});
export const parseHomepageAsCode = (input, source) => {
    const result = documentSchema.safeParse(input);
    if (!result.success) {
        const issue = result.error.issues[0];
        throw new ParameterError(`Invalid homepage file "${source}" at ${issue.path.join('.')}: ${issue.message}`);
    }
    return result.data;
};
//# sourceMappingURL=homepages.js.map